import styled from 'styled-components'
import { BaseButtonProps } from './types'

export const BaseButton = (props: BaseButtonProps) => {
  return <BaseButtonStyled {...props} />
}

const BaseButtonStyled = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
`
